import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root',
})
export class MultiCertService {
  private signers: string[];

  constructor(private localStorageService: LocalStorageService) {}

  setSigners(data: string[]) {
    this.signers = data;
    this.localStorageService.store('signers', data);
  }

  getSigners() {
    if (!this.signers) {
      return this.localStorageService.retrieve('signers');
    } else {
      return this.signers;
    }
  }
}
